import { Component, OnInit, Inject, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation.service';
import { UserService } from '../../../../shared/services/user.service';
import { InspectionAdditionalObservationListsViewModel, PopupEndPoint } from '../../../inspection/models/create-inspection.model';
import { ViewCompartTypeCommentComponent } from '../view-compart-type-comment/view-compart-type-comment.component';
import { GenericIdName } from '../../../../../app/shared/models/common-search-filters.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';



@Component({
  selector: 'component-comment-modal',
  templateUrl: './component-comment-modal.component.html',
  styleUrls: ['./component-comment-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentCommentModalComponent implements OnInit {
  private inspectionDetailId: number;
  private inspectionId: number;
  comment: string;
  savingComment = false;
  isInspector = false;
  isInterpreter = false;
  newComment = '';
  observationList: InspectionAdditionalObservationListsViewModel;
  endPoint: PopupEndPoint;
  showplus: boolean = false;
  CompartTypeId: number;
  @Output() updateComment_: EventEmitter<any> = new EventEmitter();
  AddtoInterpretationComment: boolean;
  screenId: number;
  SystemId: number = 0;

  constructor(
    private _dialogRef: MatDialogRef<ComponentCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _dialog: MatDialog,
    private _user: UserService) { }



  ngOnInit() {
    this.checkPermissions();


    if (this._data.comingFrom) {
      this.endPoint = this._data.comingFrom;
      switch (this.endPoint) {
        case PopupEndPoint.ObservationListInterpretation:

          this.observationList = this._data.observationList;
          this.comment = this.observationList.Comment;
          this.newComment = this.observationList.Comment;
          this.showplus = false;
          break;
      }
    } else {
      this.inspectionDetailId = this._data.inspectionDetailId;
      this.inspectionId = this._data.inspectionId;
      this.comment = this._data.comment;
      this.newComment = this._data.comment;
      this.showplus = this._data.showplus;
      this.CompartTypeId = this._data.CompartTypeId;
      this.screenId = this._data.ScreenId;
      this.SystemId = this._data.SystemId;
      if (this.SystemId != 0) {
        this.newComment = this._data.comment;
      }
      this.LoadCompartTypeComments();


    }
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
            case 'Undercarriage ONLY':
            case 'Undercarriage Inspector ONLY':
              this.isInspector = true;
              break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  updateComment() {

    this.savingComment = true;
    
      if(this.screenId == PopupEndPoint.CreateEditInspectionComponent){
        this._dialogRef.close({Comment:this.newComment,ScreenId:this.screenId, SystemId:this.SystemId});
      }else{
        if (this.endPoint) {
        switch (this.endPoint) {
          case PopupEndPoint.ObservationListInterpretation:
            this._interp.UpdateInspectionObservationListComment(this.observationList.Id, this.newComment).subscribe((r: any) => {
              if (r > 0) {
                this.success('Saved', 'Successfully Saved Observation List Comment');
              }
            }, err => {
              this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
            });

            break;

        }
      } else {
        if (this.SystemId > 0) {
          this._interp.UpdateSystemComment(this.SystemId, this.newComment, this.inspectionId).subscribe((r: any) => {
            if (r > 0) {
              this.success('Saved', 'Successfully Saved System Comment');
            }
          }, err => {
            this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
          });
        } else {
          this._interp.updateComponentComment(this.inspectionId, this.inspectionDetailId, this.newComment, this.AddtoInterpretationComment, this.screenId).subscribe(r => {
            if (r.m_Item1) {
              this.success('Saved', r.m_Item2);
            } else {
              this.error('Failed', r.m_Item2, r.m_Item2);
            }
          }, err => {
            this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
          });
        }
      
    }
      }
      
  }


  success(title: string, message: string) {
    this._notify.success(title, message);
    this._dialogRef.close(true);
    this.savingComment = false;
  }

  error(title: string, message: string, err: any) {
    this._notify.error(title, message);
    console.error(err);
    this.savingComment = false;
  }


  // commentChanged(newComment: string) {
  //   this.newComment = newComment;
  // }


  CompartTypeCommentList: GenericIdName[] = [];
  compartTypeComment: string;

  LoadCompartTypeComments() {
    if (this.SystemId == 0) {
      this._interp.GetComponentTypeComments(this.CompartTypeId, this.inspectionId).subscribe(r => {
        this.CompartTypeCommentList = r;
      }, err => {
        this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
      });
    }

  }
  AddCompartTypeComment() {
    if (this.newComment != null && this.newComment != "") {
      this.newComment += "\n" + this.compartTypeComment;
    } else {
      this.newComment = this.compartTypeComment;
    }
  }
  onNoClick(): void {
    this._dialogRef.close(false);
  }
}
